import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Check, Zap, Package, Home as HomeIcon, Sparkles } from 'lucide-react';

const Tarifs = () => {
  const [billingCycle, setBillingCycle] = useState('single');

  const pricingPlans = [
    {
      id: 1,
      icon: HomeIcon,
      name: "Nettoyage Express",
      subtitle: "À l'unité",
      price: "150",
      unit: "DH",
      period: "par nettoyage",
      description: "Parfait pour les turnovers occasionnels",
      features: [
        "Nettoyage complet 1h",
        "Changement de linge",
        "Photos avant/après",
        "Réponse en 15 min",
        "Checklist 27 points",
        "Produits inclus"
      ],
      popular: false
    },
    {
      id: 2,
      icon: Package,
      name: "Abonnement 8×",
      subtitle: "Mensuel",
      price: "1000",
      unit: "DH",
      period: "par mois",
      description: "Pour hôtes réguliers - Économisez 30 DH par nettoyage",
      features: [
        "8 nettoyages par mois",
        "Priorité de réservation",
        "Agent dédié",
        "Rapport mensuel",
        "Produits inclus",
        "Garantie satisfaction"
      ],
      popular: true,
      savings: "Économisez 240 DH/mois"
    },
    {
      id: 3,
      icon: Zap,
      name: "Service Urgence",
      subtitle: "< 4 heures",
      price: "170",
      unit: "DH",
      period: "par intervention",
      description: "Intervention rapide pour les imprévus",
      features: [
        "Arrivée en moins de 4h",
        "Disponible 7j/7",
        "Nettoyage complet express",
        "Photos en temps réel",
        "Garantie qualité",
        "Produits inclus"
      ],
      popular: false
    },
    {
      id: 4,
      icon: Sparkles,
      name: "Nettoyage Profond",
      subtitle: "Remise à neuf",
      price: "600",
      unit: "DH",
      period: "par intervention",
      description: "Pour préparation de saison ou après travaux",
      features: [
        "Nettoyage intensif ",
        "Vitres intérieures/extérieures",
        "Dégraissage cuisine",
        "Détartrage salle de bain",
        "Traitement anti-bactérien",
        "Produits spécialisés inclus"
      ],
      popular: false
    }
  ];

  const additionalServices = [
    { name: "Linge de maison (draps + serviettes)", price: "30 DH" },
    { name: "Repassage linge (par panier)", price: "40 DH" },
    { name: "Nettoyage balcon/terrasse", price: "25 DH" },
    { name: "Nettoyage réfrigérateur", price: "20 DH" },
    { name: "Nettoyage four", price: "25 DH" },
    { name: "Gestion des clés(checkout) ", price: "Gratuit" }
  ];

  return (
    <div className="tarifs-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1>Tarifs Transparents</h1>
          <p>Prix clairs, pas de frais cachés. Qualité garantie à chaque intervention.</p>
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="pricing-section">
        <div className="section-container">
          <h2>Choisissez Votre Formule</h2>
          <p className="pricing-subtitle">Tous nos tarifs incluent les produits de nettoyage professionnels</p>
          
          <div className="pricing-grid">
            {pricingPlans.map((plan) => {
              const IconComponent = plan.icon;
              return (
                <div key={plan.id} className={`pricing-card ${plan.popular ? 'popular' : ''}`}>
                  {plan.popular && (
                    <div className="popular-badge-pricing">⭐ LE PLUS POPULAIRE</div>
                  )}
                  
                  <div className="pricing-icon">
                    <IconComponent size={40} />
                  </div>
                  
                  <h3>{plan.name}</h3>
                  <p className="pricing-subtitle-text">{plan.subtitle}</p>
                  
                  <div className="pricing-amount">
                    <span className="amount">{plan.price}</span>
                    <span className="unit">{plan.unit}</span>
                  </div>
                  <p className="pricing-period">{plan.period}</p>
                  
                  {plan.savings && (
                    <div className="savings-badge">{plan.savings}</div>
                  )}
                  
                  <p className="pricing-description">{plan.description}</p>
                  
                  <ul className="pricing-features">
                    {plan.features.map((feature, idx) => (
                      <li key={idx}>
                        <Check size={18} />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <Link to="/contact" className={plan.popular ? 'gradient-btn' : 'outline-btn'}>
                    {plan.popular ? "S'abonner" : "Réserver"}
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="additional-services-section">
        <div className="section-container">
          <h2>Services Supplémentaires</h2>
          <p className="section-subtitle">Personnalisez votre prestation selon vos besoins</p>
          
          <div className="additional-services-grid">
            {additionalServices.map((service, index) => (
              <div key={index} className="additional-service-item">
                <span className="service-name">{service.name}</span>
                <span className="service-price">{service.price}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Pricing */}
      <section className="pricing-faq-section">
        <div className="section-container">
          <h2>Questions sur les Tarifs</h2>
          <div className="faq-simple-grid">
            <div className="faq-simple-item">
              <h4>Comment fonctionne l'abonnement?</h4>
              <p>Vous payez 1,200 DH au début du mois pour 8 nettoyages. Si vous avez besoin de plus, tarif préférentiel à 150 DH/nettoyage supplémentaire.</p>
            </div>
            <div className="faq-simple-item">
              <h4>Les produits sont-ils inclus?</h4>
              <p>Oui, tous nos tarifs incluent les produits de nettoyage professionnels. Vous n'avez rien à fournir.</p>
            </div>
            <div className="faq-simple-item">
              <h4>Comment je paie?</h4>
              <p>Virement bancaire, cash ou mobile money. Facture fournie après chaque intervention.</p>
            </div>
            <div className="faq-simple-item">
              <h4>Y a-t-il des frais de déplacement?</h4>
              <p>Non, nos tarifs incluent déjà le déplacement dans toute la ville de Meknès.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="service-cta">
        <h2>Prêt à Commencer?</h2>
        <p>Rejoignez 50+ hôtes Airbnb satisfaits à Meknès</p>
        <div className="cta-buttons">
          <Link to="/contact" className="white-btn">Réserver Maintenant</Link>
          <a href="https://wa.me/212653555855" target="_blank" rel="noopener noreferrer" className="outline-white-btn">
            Questions? WhatsApp
          </a>
        </div>
      </section>
    </div>
  );
};

export default Tarifs;
